import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { waLink } from "../../lib/site";

export const PublicLayout = () => {
  const { pathname } = useLocation();
  const onTour = /^\/(group|family)-tours\/[^/]+/.test(pathname);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <a href={waLink()} target="_blank" rel="noreferrer" aria-label="Chat with Wandervibe on WhatsApp" data-testid="floating-whatsapp-btn"
         className={`fixed right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 ${onTour ? "bottom-24 lg:bottom-6" : "bottom-6"}`}>
        <WhatsAppIcon className="h-7 w-7" />
      </a>
    </div>
  );
};

export const SectionTitle = ({ eyebrow, title, sub, center }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2 className="mt-3 text-2xl text-[#171717] sm:text-3xl lg:text-4xl">{title}</h2>
    {sub && <p className="mt-4 text-base font-medium text-slate-600 md:text-lg" style={{ fontFamily: "Montserrat" }}>{sub}</p>}
  </div>
);
